import { Routes } from '@angular/router'
import { BaseComponent } from './core/template/base/base.component'
import { LoginComponent } from './pages/login/login/login.component'
import { AuthGuard } from './core/guards/auth.guard'
import { HomeComponent } from './pages/home/home/home.component'
import { ProfileComponent } from './pages/profile/profile/profile.component'
import { AddressTypeComponent } from './pages/address/address-type/address-type.component'
import { VehicleTypeComponent } from './pages/vehicle/vehicle-type/vehicle-type.component'
import { VehicleModelComponent } from './pages/vehicle/vehicle-model/vehicle-model.component'
import { DriverTypeComponent } from './pages/health-agent/driver-type/driver-type.component'
import { SubtypeExamComponent } from './pages/subtype-exam/subtype-exam/subtype-exam.component'
import { HabitComponent } from './pages/habit/habit/habit.component'
import { UnitTypeComponent } from './pages/unit-type/tax-document-type/unit-type.component'
import { PriceQuoteStatusComponent } from './pages/price-quote/price-quote-status/price-quote-status.component'
import { ContractStatusComponent } from './pages/contract/contract-status/contract-status.component'
import { AddressComponent } from './pages/address/address/address.component'
import { BankDetailsComponent } from './pages/bank/bank-details/bank-details.component'
import { PersonTypeComponent } from './pages/person/person-type/person-type.component'
import { PatientComponent } from './pages/patient/patient/patient.component'
import { SupplierComponent } from './pages/person/supplier/supplier.component'
import { HealthUnitComponent } from './pages/health-unit/health-unit/health-unit.component'
import { HealthAgentComponent } from './pages/health-agent/health-agent/health-agent.component'
import { ExamTypeComponent } from './pages/exam-type/exam-type/exam-type.component'
import {ClassificationComponent} from './pages/classification/classification.component';
import {MonitoringComponent} from './pages/monitoring/monitoring/monitoring.component';
import {AdminComponent} from './pages/admin/driver/admin.component';
import {MunicipalityComponent} from './pages/municipality/municipality/municipality.component';
import {MessageComponent} from './pages/message/message.component';
import {ContextComponent} from './pages/context/context.component';
import {AlertRuleComponent} from './pages/alert-rule/alert-rule/alert-rule.component';
import {MeasureReportComponent} from './pages/reports/measure-report/measure-report.component';
import {
  MunicipalityCentralComponent
} from './pages/municipality-central/municipality-central/municipality-central.component';
import {MedicalInsuranceComponent} from './pages/medical-insurance/medical-insurance/medical-insurance.component';
import {MessageTypeComponent} from './pages/message-type/message-type/message-type.component';
import {ContentTypeComponent} from './pages/content-type/message-type/content-type.component';
import {ContentSugestionComponent} from './pages/content-sugestion/content-sugestion.component';
import {
  PendingPatientAlertsComponent
} from './pages/pending-patient-alerts/pending-patient-alerts/pending-patient-alerts.component';
import {ResetPasswordComponent} from './pages/login/reset-password/reset-password.component';
import {PreviousDiseasesComponent} from './pages/previous-diseases/previous-diseases/previous-diseases.component';

export const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  // { path: '**', redirectTo: '/login' },
  {
    path: '',
    component: BaseComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        component: HomeComponent,
      },
      {
        path: 'relatorio-medicao',
        component: MeasureReportComponent,
      },
      {
        path: 'convenio',
        component: MedicalInsuranceComponent,
      },
      {
        path: 'central-hiperdia',
        component: MunicipalityCentralComponent,
      },
      // Cadastros
      {
        path: 'classificacao',
        component: ClassificationComponent,
      },
      {
        path: 'municipio',
        component: MunicipalityComponent,
      },
      {
        path: 'mensageria',
        component: MessageComponent,
      },
      {
        path: 'administrador',
        component: AdminComponent,
      },  {
        path: 'doencas-previas',
        component: PreviousDiseasesComponent,
      },
      {
        path: 'dados-bancario',
        component: BankDetailsComponent,
      },
      {
        path: 'endereco',
        component: AddressComponent,
      },
      {
        path: 'exame',
        component: SubtypeExamComponent,
      },
      {
        path: 'habito',
        component: HabitComponent,
      },
      {
        path: 'contexto-medicao',
        component: ContextComponent,
      },
      {
        path: 'regra-alerta',
        component: AlertRuleComponent,
      },
      {
        path: 'unidade-saude',
        component: HealthUnitComponent,
      },
      {
        path: 'fabricante',
        component: VehicleModelComponent,
      },
      {
        path: 'alertas-pendentes',
        component: PendingPatientAlertsComponent,
      },
      // {
      //   path: 'perfil',
      //   component: ProfileTestComponent,
      // },
      // Tipos
      {
        path: 'tipo-perfil',
        component: ProfileComponent,
      },
      {
        path: 'tipo-exame',
        component: ExamTypeComponent,
      },
      {
        path: 'tipo-unidade-medida',
        component: UnitTypeComponent,
      },
      {
        path: 'tipo-endereco',
        component: AddressTypeComponent,
      },
      {
        path: 'tipo-motorista',
        component: DriverTypeComponent,
      },
      {
        path: 'tipo-pessoa',
        component: PersonTypeComponent,
      },
      {
        path: 'tipo-veiculo',
        component: VehicleTypeComponent,
      },
      // Status
      {
        path: 'status-contrato',
        component: ContractStatusComponent,
      },
      {
        path: 'status-cotacao',
        component: PriceQuoteStatusComponent,
      },
      {
        path: 'cliente',
        component: PatientComponent,
      },
      // {
      //   path: 'equipamentos',
      //   component: SupplierComponent,
      // },
      {
        path: 'tutor-local',
        component: HealthAgentComponent,
      },
      {
        path: 'monitoramento',
        component: MonitoringComponent,
      },
      {
        path: 'tipo-uso',
        component: MessageTypeComponent,
      },
      {
        path: 'conteudo-sugestao',
        component: ContentSugestionComponent,
      },
      {
        path: 'tipo-conteudo',
        component: ContentTypeComponent,
      },
      {
        path: 'paciente',
        component: PatientComponent,
      }
    ],
  },
]
